import i18n from '../../../config/i18n';

export const tags = [
  { value: 'search', label: i18n.t('searchAllFields') },
  { value: 'name', label: i18n.t('Username') },
  { value: 'archive', label: i18n.t('archive') },
  { value: 'status', label: i18n.t('status') },
  { value: 'brokers', label: i18n.t('Brokers') },
];
